import { Ng2StateDeclaration } from '@uirouter/angular';
import { RoleEditComponent } from '@fi-app/role/role-edit/role-edit.component';
import { ExtendedRoleRightService } from '../services/extended-role-right.service';
import { ModuleType } from '@fi-shared/types/module-type';
import { PageTitleService } from '@fi-app/utilities/fi-services/page-title.service';
import { FiRoleStateResolveRoleEdit } from '@fi-app/role/states/resolve/role';
import { FiRoleStateResolveAllRoles } from '@fi-app/role/states/resolve/all-roles';
import { FiStateService } from '@fi-shared/fi-state-proxy/fi-state.proxy.service';
import { Transition } from '@uirouter/core';
import { coerceNumberProperty } from '@angular/cdk/coercion';
import { FiStateNames } from '@fi-shared/fi-state-proxy/fi-state-names';
import { RoleModel } from '@fi-app/role/role.model';

export const FiRoleEditState: Ng2StateDeclaration = {
    name: FiStateNames.Role.Edit,
    url: '/:Id/Edit',
    params: {
        selectedLayout: null,
    },
    views: {
        '@': {
            component: RoleEditComponent,
        },
    },
    resolve: {
        role: FiRoleStateResolveRoleEdit,
        allRoles: FiRoleStateResolveAllRoles,
        extendedRoleRoles: ['role', ExtendedRoleRightService, FiRoleEditStateResolve_extendedRoleRoles],
        selectedLayout: [FiStateService, Transition, FiRoleEditStateResolve_selectedLayout],
        pageTitle: [PageTitleService, 'role', FiRoleEditStateResolve_pageTitle],
    },
};

export function FiRoleEditStateResolve_extendedRoleRoles(
    role: RoleModel,
    extendedRoleRightService: ExtendedRoleRightService,
) {
    return extendedRoleRightService.GetLightWeightRoles(role.Id || 0, ModuleType.Core);
}

export function FiRoleEditStateResolve_pageTitle(ccmPageTitle: PageTitleService, Role) {
    return ccmPageTitle.setTitleByItem(Role);
}

export function FiRoleEditStateResolve_selectedLayout(fiStateService: FiStateService, tr: Transition) {
    return coerceNumberProperty(fiStateService.getParams(tr).selectedLayout);
}
